import React from "react";
import { useCmsContent } from "@/hooks/useCmsContent";

import NavigationBanner from "@/components/navigation-banner/navigation-banner";
import NavigationFooter from "@/components/navigation-footer/navigation-footer";
import NavigationHeader from "@/components/navigation-header/navigation-header";

import HomeCafe from "./cafe/cafe";
import Hero from "./hero/hero";
import HomeOffers from "./offers/offers";
import HomeSocial from "./social/social";

import styles from './home.module.css';

const CAFE_FALLBACKS = {
    cafe_top: {
        title: 'Bradley Street Cafe',
        body: "Bradley Street Cafe is the perfect place to start your day or take a quick break. The cafe is conveniently located in select Kwik Fill locations, making it a quick and easy stop for anyone on-the-go. Whether you're in need of a caffeine fix, a quick bite, or a moment of peace and quiet, Bradley Street Cafe has you covered.",
        cta_text: 'View Details',
        cta_link: '/bradley-street-cafe',
        image_url: '/assets/home/home_cafe-hero2.png',
    },
    cafe_bottom: {
        title: 'Bradley Street Coffee',
        body: "If you're in need of a pick-me-up while on the go, look no further than Kwik Fill's selection of Bradley Street coffee. This premium coffee brand is carefully crafted to deliver a rich, smooth, and flavorful cup of coffee in every sip.",
        cta_text: 'View Locations',
        cta_link: '/stores?filter=bradleystreetcoffee',
        image_url: '/assets/home/home_cafe-hero1.png',
    },
};

export default function Home() {
    const { content, refetch } = useCmsContent('home', undefined, CAFE_FALLBACKS);
    const cafeTop = content.cafe_top || CAFE_FALLBACKS.cafe_top;
    const cafeBottom = content.cafe_bottom || CAFE_FALLBACKS.cafe_bottom;

    return (
        <div className={styles.container}>
            <div className={styles.navigation_container}>
                <NavigationBanner />
                <NavigationHeader opacity_scroll={true} />
            </div>

            <div style={{marginTop: -89}}>
                <Hero />
                <HomeOffers />
                <HomeCafe
                    title_top={cafeTop.title}
                    body_top={cafeTop.body}
                    cta_text_top={cafeTop.cta_text}
                    cta_text_link_top={cafeTop.cta_link}
                    image_url_top={cafeTop.image_url}

                    title_bot={cafeBottom.title}
                    body_bot={cafeBottom.body}
                    cta_text_bot={cafeBottom.cta_text}
                    cta_text_link_bot={cafeBottom.cta_link}
                    image_url_bot={cafeBottom.image_url}

                />
                <HomeSocial />
            </div>

            <NavigationFooter />
        </div>
    );
}
